/* import __COLOCATED_TEMPLATE__ from './thread-message-item.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { THREAD_MESSAGE_STRIPTAGS_EXCEPTIONS } from 'sh-www/constants/messages';
import { stripTags } from 'sh-www/utils/misc';
import { showModal } from "sh-www/utils/modal-controls";
import { messageCenterIsMyMessage } from '../../helpers/message-center/is-my-message';

export default Component.extend({
  media: service(),
  session: service(),
  currentUser: readOnly('session.currentUser'),

  tagName: 'li',
  classNames: ['thread-message-item'],
  classNameBindings: [
    '_isMyMessage:from-current-user:from-thread-recipient',
    '_isUnread:is-unread',
  ],

  /** @param {Date} lastReadAt When the thread was last seen by the user. */
  lastReadAt: null,

  /** @param {Function} onClick The function to call when the message is clicked. */
  onClick: () => {},

  /** @param {Function} onClick */
  onProfileLinkClick: () => {},

  /** @type {Boolean} Whether the message is unread. */
  _isUnread: computed('lastReadAt', 'message.createdAt', function () {
    if (!this.get('lastReadAt')) return false;

    return this.get('lastReadAt').getTime() < this.get('message.createdAt').getTime();
  }),

  /**
   * @type {Boolean} Whether the message belongs to the current user.
   */
  _isMyMessage: computed('message', 'currentUser', function () {
    return messageCenterIsMyMessage([this.get('message'), this.get('currentUser')]);
  }),

   /** @type {String} Sanitized thread message. */
  _messageBodySanitized: computed('message.body', function () {
    return stripTags(this.message.body, THREAD_MESSAGE_STRIPTAGS_EXCEPTIONS);
  }),

  click() {
    this.get('onClick')();
  },

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * @param {User} user
     */
    handleProfileLinkClick(user) {
      this.get('onProfileLinkClick')(user);
    },

    /**
     * Called when the user has clicked flag message
     *
     * @param {String} threadId
     */
    onFlagMessage: function(threadId) {
      let modalModel = {
        threadId: threadId
      };

      showModal(this, 'flag-user-modal', modalModel);
    },
  }
});
